<!--
  관리자/그룹 추가 팝업 (임시, 외부인증 계정 전용)

  @since: 2019-08-30
  @author: mk.ko

  * 2019-08-30 : TODO: 추후 관리자 그룹/편집 쪽 공통화 작업 필요
-->

<template>
  <layout-popup ref="adminGroupAddPopup"
                :isOpen.sync="isOpen"
                :titleName="getTitle"
                :confirmEvt="onConfirm"
                :cancelEvt="onCancel"
                :footerBtn="['confirm', 'cancel']"
                :content-css="{minWidth: '600px', minHeight: '213px'}">
    <div>
      <div class="content-group">
        <div class="contents-row">

          <div class="portlet">

            <div class="contents-row">

              <table class="bs-table table-bordered-none">

                <colgroup>
                  <col width="170px"/>
                  <col width="auto"/>
                </colgroup>

                <tbody>

                  <tr>
                    <td class="td-head">
                      {{$t('sm.deviceConfig_deviceGroupConfig_parentGroupName')}} <span class="textR">*</span>
                    </td>
                    <td>
                      <div class="inline-group">
                        <q-input class="bs bs-q-input bs-q-input-default"
                                 style="width:100%;"
                                 v-model="popupAdminParentName"
                                 disable>
                      </q-input>
                      </div>
                    </td>
                  </tr>

                <tr>
                  <td class="td-head">
                    {{$t('cmn.name')}} <span class="textR">*</span>
                  </td>
                  <td>
                    <div class="inline-group">
                      <q-input class="bs bs-q-input bs-q-input-default"
                               style="width:100%;"
                               v-model="popupAdminName"
                               name="popupAdminName"
                               data-vv-scope="main"
                               v-validate="`required|min:2|max:32`"
                               :error="errors.has('main.popupAdminName')"
                               :maxLength="32"
                               @keydown.enter="onConfirm">
                        <tool-tip minLength="2" maxLength="32" />
                      </q-input>
                    </div>
                  </td>
                </tr>

                </tbody>

              </table>

            </div>

          </div>
        </div>
      </div>

    </div>
  </layout-popup>
</template>

<script>
  import LayoutModalPopUp from '~/components/popUp/LayoutModalPopUp'

  // import {createNamespacedHelpers} from 'vuex'

  export default {
    name: 'IpAddPopup',
    props: {
      externalAuth: {
        type: Boolean,
        default: false
      }
    },
    components: {
      'layout-popup': LayoutModalPopUp
    },
    data () {
      return {
        isOpen: false,
        popupAdminParentName: '',
        popupAdminName: ''
      }
    },
    created () {
      // this.$nextTick(() => {})
    },
    computed: {
      getTitle () {
        return this.$t('sm.externalAuthSettings_adminGroupAddPopup_externalAuthAccountAdding')
      }
    },
    methods: {
      popupInit () {
        this.popupAdminParentName = ''
        this.popupAdminName = ''
      },
      async show ({ parentName = '' } = {}) {
        this.popupInit()
        this.$validator.reset()

        this.popupAdminParentName = parentName
        await this.$refs.adminGroupAddPopup.show()
      },
      hide () {
        this.$refs.adminGroupAddPopup.hide()
      },
      async validate (groupName) {
        await this.$validator.validateAll(groupName)
        if (this.$validator.errors.count() === 0) {
          return true
        }
        for (const item of this.$validator.errors.items) {
          if (item.scope === groupName) {
            this.$validatePopUp.show(this.$validator.errors.items)
          }
        }
        return false
      },
      // 관리자 아이피 팝업 확인
      async onConfirm () {
        let result = await this.validate('main')
        if (result === true) {
          this.$emit('confirm', {
            adminName: this.popupAdminName
          })
        }
      },
      onCancel () {}
    },
    watch: {}
  }
</script>

<style scoped>
</style>
